export default [
    {
        path: '/futures/agent',
        component: () => import("@/pages/v2/agent"),
    },
    {
        path: '/futures/agent/rebate-code',
        component: () => import("@/pages/v2/agent/rebate/code.vue"),
    },
  ];


// WEBPACK FOOTER //
// ./src/router/v2/agent/index.js